export function readRuntimePerformanceHudEnabled(
  rawValue: string | boolean | undefined,
  defaultEnabled: boolean,
): boolean {
  if (typeof rawValue === "boolean") {
    return rawValue;
  }
  if (typeof rawValue !== "string") {
    return defaultEnabled;
  }
  const normalized = rawValue.trim().toLowerCase();
  if (!normalized) {
    return defaultEnabled;
  }
  return !["0", "false", "off", "no"].includes(normalized);
}
